module.exports = __webpack_public_path__ + "assets/img/GLJY-1.81eb5fc8.jpg";